// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__QYqNS","cell":"ColumnAccessor_cell__N1fW9","firstCellAccent":"ColumnAccessor_firstCellAccent__1LVCI"};